import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Product } from '@spartacus/core';
import {isPortugal, isValencia} from 'src/app/utils/check-environment';

@Component({
    selector: 'app-gonvarri-chapa-quantity',
    templateUrl: './gonvarri-chapa-quantity.component.html',
    styleUrl: './gonvarri-chapa-quantity.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GonvarriChapaQuantityComponent implements OnInit, OnChanges {

  @Input() product: Product = {} as Product;
  @Input() numberOfSheets: number = 10;
  @Input() packageWeigth: number = 1000;
  @Input() hideTexts: boolean | undefined = false;

  @Input() lenght: number = 0;

  @Output() updatePackageAndSheets = new EventEmitter<number[]>();
  @Output() disableAddToCart = new EventEmitter<boolean>();
  @Output() packProductFixedWeight = new EventEmitter<number>();

  productType: string = "";

  MAX_KG: number = isValencia() ? 4500 : isPortugal() ? 4000 : 5000;
  MIN_KG: number = isValencia() || isPortugal() ? 2500 : 1000;

  KG_EACH: number = 0;

  ngOnInit(): void {
    this.defineProductType();
    this.calcKgEach();
    this.updateAddToCartButton();
  }

  ngOnChanges(): void {
    this.defineProductType();
    this.calcKgEach();
    this.updateAddToCartButton();
  }

  defineProductType(): void {
    this.productType = this.product.categories?.find(category => category.code?.includes("productType"))?.code as string;
    if(this.productType === undefined) {
      this.productType = "";
    }
  }

  calcKgEach(): void {
    const width = Number((this.product.categories?.find(category => category.code?.includes("width"))?.name as string).replaceAll(",", ""));
    const thickness = Number((this.product.categories?.find(category => category.code?.includes("thickness"))?.name as string).replaceAll(",", ""));
    let length: string | number = (this.product.categories?.find(category => category.code?.includes("length"))?.name as string).replaceAll(",", "");
    if(isNaN(Number(length))) {
      length = this.lenght;
    }
    this.KG_EACH = ((thickness * width * Number(length) * 7.85) / 1000000);
  }

  getValueCategory(): number {
    const value = Number(this.productType.replace("productType_", "").replace("_pack", "")) * 1000;
    this.updatePackProductFixedWeight(value);
    return value;
  }

  updatePackProductFixedWeight(value: number): void {
    this.packProductFixedWeight.emit(value);
  }

  updateValuesPackage(): void {
    this.updateValues(this.packageWeigth, 10);
  }

  updateValuesNumber(): void {
    this.updateValues(1000, this.numberOfSheets);
    this.updateAddToCartButton();
  }

  private updateValues(packageWeigth: number, numberOfSheets: number): void {
    this.updatePackageAndSheets.emit([packageWeigth, numberOfSheets]);
    this.updateAddToCartButton();
  }

  private updateAddToCartButton(): void {
    let isDisabled = false;
    if(this.productType.includes('productType_raw')) {
      isDisabled = ((this.packageWeigth) < this.MIN_KG) || ((this.packageWeigth) > this.MAX_KG);
    }else if(this.productType.includes('productType_sheet')) {
      isDisabled = ((this.numberOfSheets * this.KG_EACH) < this.MIN_KG) || ((this.numberOfSheets * this.KG_EACH) > this.MAX_KG);
    }
    this.disableAddToCart.emit(isDisabled);
  }

  public ceilTotalKg(value: number): number {
    return Math.ceil(value);
  }

}
